<template>
  <div class="nosotros bg-white">
    <div class="portada-nosotros d-flex align-items-center justify-content-center flex-wrap px-2 borde-sombreado">
      <div class="px-2">
        <h1 class="w-100">ADGSystems</h1>
        <h2 class="w-100 m-0 p-0">Grupo de Desarrollo de Aplicaciones</h2>
      </div>
    </div>
    <somos></somos>
    <historia class="borde-sombreado bg-light"></historia>
    <mision-vision-valores></mision-vision-valores>
  </div>
</template>
<script>
import MisionVisionValores from "@/components/cliente/paginas/nosotros/mvv.vue";
import Historia from "@/components/cliente/paginas/nosotros/historia.vue";
import Somos from "@/components/cliente/paginas/nosotros/somos.vue";
export default {
  data() {
    return {
      slide: 0,
      sliding: null
    };
  },
  components: {
    MisionVisionValores,
    Somos,
    Historia
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped>
.portada-nosotros {
  height: 420px;
  width: 100%;
  min-height: 50vh;
  color: white;
  background: #262626;
  background: url("../../assets/images/portadas/nosotros.jpeg");
  background-size: cover;
}
.portada-nosotros h1 {
  font-size: calc(3.4em + 1vh);
  letter-spacing: -1px;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}
.portada-nosotros h2 {
  font-size: calc(2.2em + 1vh);
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}
@media (max-width: 480px) {
  .portada-nosotros {
    min-height: 30vh;
  }
}
.borde-sombreado {
  -webkit-box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
  -moz-box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
  box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
}
</style>